export default __webpack_public_path__ + "navigation-camera-bearing-smoothing-enabled-1200-e606af617a03bb96f7b9714fde153ad8.webp";